import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import 'what-input';
import rootUnits from 'root-units';
import GiraLight from 'chaoskit/src/assets/fonts/gira-sans-light.woff';
import GiraLightItalic from 'chaoskit/src/assets/fonts/gira-sans-light-italic.woff';
import GiraMedium from 'chaoskit/src/assets/fonts/gira-sans-regular.woff';
import GiraBold from 'chaoskit/src/assets/fonts/gira-sans-bold.woff';
import CircularBook from 'chaoskit/src/assets/fonts/lineto-circular-book.woff';
import CircularMedium from 'chaoskit/src/assets/fonts/lineto-circular-medium.woff';
import CircularBlack from 'chaoskit/src/assets/fonts/lineto-circular-black.woff';
import { styles } from 'chaoskit/src/helpers/styles';

import '../assets/styles/site.scss';
import { defaultFeaturedImage } from '../../utils/helpers';

const Foundation = ({ children }) => {
  useEffect(() => {
    rootUnits.install();
  }, []);

  const {
    site: {
      siteMetadata: { title, description },
    },
  } = useStaticQuery(graphql`
    query FoundationPageData {
      site {
        siteMetadata {
          title
          description
        }
      }
    }
  `);

  return (
    <Fragment>
      <Helmet
        title={title}
        meta={[
          { name: 'description', content: description },
          {
            property: 'og:image',
            content: defaultFeaturedImage,
          },
        ]}
        htmlAttributes={{
          lang: 'en',
        }}
      >
        {/* Adding in webfonts here to get around strange Gatsby issue https://github.com/gatsbyjs/gatsby/issues/9826 */}
        <style type="text/css">
          {`
              @font-face {
                font-family: Gira;
                src: local(😜), url(${GiraLight}) format('woff');
                font-weight: ${styles.typography.weight.normal};
                font-style: normal;
              }

              @font-face {
                font-family: Gira;
                src: local(😜), url(${GiraLightItalic}) format('woff');
                font-weight: ${styles.typography.weight.normal};
                font-style: italic;
              }

              @font-face {
                font-family: Gira;
                src: local(😜), url(${GiraMedium}) format('woff');
                font-weight: ${styles.typography.weight.medium};
                font-style: normal;
              }

              @font-face {
                font-family: Gira;
                src: local(😜), url(${GiraBold}) format('woff');
                font-weight: ${styles.typography.weight.bold};
                font-style: normal;
              }

              @font-face {
                font-family: Circular;
                src: local(😜), url(${CircularBook}) format('woff');
                font-weight: ${styles.typography.weight.normal};
                font-style: normal;
              }

              @font-face {
                font-family: Circular;
                src: local(😜), url(${CircularMedium}) format('woff');
                font-weight: ${styles.typography.weight.medium};
                font-style: normal;
              }

              @font-face {
                font-family: Circular;
                src: local(😜), url(${CircularBlack}) format('woff');
                font-weight: ${styles.typography.weight.bold};
                font-style: normal;
              }
            `}
        </style>
      </Helmet>
      {children}
    </Fragment>
  );
};

Foundation.propTypes = {
  children: PropTypes.node,
};

export default Foundation;
